<template>
  <div class="index list" @scroll="onScroll">
    <div class="index-mainBackground">
    </div>
    <div class="index-item">
      <div class="cards">
        <div class="card" v-for="item in list" v-if="list.length > 0">
          <div class="card-title">
            <span>{{ item.name }}</span>
            <span class="sub">{{ item.mobile }}</span>
            <span class="sub">{{ item.province }}/{{ item.city }}/{{ item.district }}/{{ item.address }}</span>
            <div v-if="item.default">
              <span class="default">默认地址</span>
            </div>
          </div>
          <div class="card-btn" @click="clickAddressItem(item)">
            编辑
          </div>
        </div>
        <div v-else class="index-empty">暂无地址</div>
      </div>
      <div class="index-btn">
        <button @click="newAddress">新增收件人地址</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import area from '@/util/area'
import { Toast, List } from 'vant'

Vue.use(Toast).use(List)

export default {
  name: 'Address',
  data() {
    return {
      area: area,
      list: [],
      loading: false,
      finished: false,
      page: 0,
      totalPage: 1,
      total: 10,
    }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    onScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      // 当滚动到底部时触发加载
      if (scrollTop + clientHeight === scrollHeight) {
        console.log('触底了哈哈哈哈哈')
        if (this.total > this.page * this.size) {
          this.page += 1
          this.getList()
        }

      }
    },
    getList() {
      var that = this
      var params = { page: this.page + 1 }
      this.axios.get('/user/address/', { params: params }).then(function (res) {
        that.loading = false
        that.list = that.list.concat(res.data.records)
        // if (res.data.records.length == 0) that.list = res.data.records
        that.page = res.data.current
        that.totalPage = res.data.pages
        that.total = res.data.total
      }).catch(function (error) {
        console.log(error)
      })
    },
    loadMore() {
      if (this.totalPage === this.page) {
        this.finished = true
        this.loading = false
      } else {
        this.getList()
      }
    },

    /**
     * 点击地址
     */
    clickAddressItem(item) {
      if (this.$route.query.action === 'select') {
        this.axios.get('/user/address/' + item.id + '/').then(res => {
          const payload = { address: res.data }
          this.$store.dispatch('setAddress', payload).then(() => {
            this.$router.go(-1)
          })
        })
      } else {
        this.$router.push({ name: 'AddressEdit', params: { id: item.id } })
      }
    },

    newAddress() {
      this.$router.push({ name: 'AddressEdit' })
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  &-mainBackground {
    width: 100vw;
    position: absolute;
    top: 0;
    height: 233px;
    background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);
    // z-index: -1;
  }
  &-item {
    position: relative;
    top: 0;
    padding-bottom: 100px;

  }
  .cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 15px;
    margin-left: 16px;
    margin-right: 16px;

    .card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 5px;
      padding: 20px;
      background: #ffffff;
      border-radius: 16px;
      box-sizing: border-box;

      &-title {
        display: flex;
        flex-direction: column;
        gap: 5px;
        font-size: 14px;
        font-weight: 400;
        color: #000000;

        .sub {
          max-width: 230px;
          font-size: 12px;
          font-weight: 400;
          color: #a0aec0;
        }

        .default {
          font-size: 14px;
          color: #FAC859;
        }
      }



      &-btn {
        font-size: 14px;
        color: #FAC859;
        font-family: PingFangSC, PingFang SC;

      }
    }
  }

  &-btn {
    position: fixed;
    bottom: 35px;
    left: 0;
    right: 0;
    padding-bottom: 20px;
    margin-left: 15px;
    margin-right: 15px;

    button {
      width: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 15px;
      background: #FAC859;
      box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
      border-radius: 12px;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      border-style: none
    }
  }

}

.list {
  overflow-y: scroll;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/address/index.vue